export const orderAlphabetically = (array: any[], compareWith: string) =>
  [...array].sort((a, b) => a[compareWith].localeCompare(b[compareWith]));

export const returnAlphabeticalOrder = (array: any[]) =>
  [...array].sort((a, b) => a.localeCompare(b));
